const TikTokIcon = (): JSX.Element => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_5951_36416)">
			<mask
				id="mask0_5951_36416"
				style={{ maskType: 'luminance' }}
				maskUnits="userSpaceOnUse"
				x="0"
				y="0"
				width="24"
				height="24"
			>
				<path d="M24 0H0V24H24V0Z" fill="white" />
			</mask>
			<g mask="url(#mask0_5951_36416)">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M5.41992 0H18.5801C20.0162 0.00414176 21.3925 0.579159 22.408 1.59943C23.4235 2.6197 23.9958 4.0023 24 5.44518V18.5568C23.9954 19.9994 23.4228 21.3814 22.4073 22.4013C21.3918 23.4211 20.0159 23.9958 18.5801 24H5.41992C3.98407 23.9958 2.60818 23.4211 1.5927 22.4013C0.577214 21.3814 0.00463753 19.9994 0 18.5568V5.44518C0.00412255 4.0023 0.576472 2.6197 1.59202 1.59943C2.60755 0.579159 3.98374 0.00414176 5.41992 0Z"
					fill="#160C1A"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M15.1501 2.95508C15.4411 5.45299 16.9313 7.21507 19.3357 7.37205V9.74048V7.72917C16.9157 7.57416 15.5309 6.08287 15.2341 3.58691H12.695V14.0946C13.0641 18.8256 9.39622 18.9669 7.99192 17.1734C9.62862 18.2074 12.3044 17.5344 11.9841 13.4648V2.95508H15.1501ZM8.29078 20.3777C7.56957 20.2342 6.88504 19.9447 6.27893 19.5267C5.67281 19.1087 5.15782 18.571 4.76535 17.9465C2.89426 14.8717 4.58176 9.85816 10.0095 9.34216V10.0819C4.96848 10.8884 4.46262 16.3178 5.8591 18.5783C6.42815 19.453 7.29229 20.0919 8.2927 20.3777H8.29078Z"
					fill="#26F4EE"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M15.877 3.74005C16.043 5.16267 16.5645 6.39887 17.4258 7.23085C16.211 6.60098 15.4844 5.40402 15.2539 3.74005H15.877ZM19.3222 8.24137C19.5338 8.28753 19.7487 8.31705 19.9649 8.32969V11.1298C18.5664 11.2691 17.3418 10.806 15.916 9.95249L16.1348 14.756C16.1348 16.3062 16.1348 17.0145 15.3125 18.4431C13.293 21.9201 9.52152 21.9181 7.28711 19.9383C10.1992 21.6179 15.2832 20.3032 15.2734 14.5971V9.34809C16.6992 10.2095 17.9238 10.6707 19.3222 10.5255V8.24137ZM9.99608 10.2645C10.3007 10.2015 10.6084 10.155 10.918 10.1251V13.0881C9.74608 13.2843 8.99608 13.6454 8.64648 14.3145C7.66992 16.2041 8.69144 17.7425 10.0527 18.239C8.3496 18.1762 6.66211 16.4199 7.83398 14.1673C8.1836 13.4963 8.81056 13.1352 9.99608 12.939V10.2645Z"
					fill="#FB2C53"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M15.2343 3.58105C15.5254 6.08289 16.9121 7.57026 19.3222 7.72528V10.5332C17.9238 10.6706 16.6992 10.2094 15.2734 9.35592V14.597C15.2851 21.4491 7.94919 21.977 5.85935 18.5725C4.46677 16.3139 4.97263 10.8825 10.0039 10.078V12.9291C8.832 13.1254 8.19136 13.4864 7.84177 14.1574C5.69333 18.3017 13.209 20.7682 12.6894 14.0907V3.58105H15.2343Z"
					fill="white"
				/>
			</g>
		</g>
		<defs>
			<clipPath id="clip0_5951_36416">
				<rect width="24" height="24" fill="white" />
			</clipPath>
		</defs>
	</svg>
)

export default TikTokIcon
